import React from 'react';
import {Icon} from 'antd';
export const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;